export const fields = [
  [
    {
      displayName: 'Strategy',
      propName: 'Strategy',
      displayProp: 'Strategy.name',
      isAssociation: true,
      hasDependent:['SalesProduct', 'DeviceTypes', 'CreativeProducts', 'CustomCriteriaPresets'],
      formatValue: ''
    },
    {
      displayName: 'Device Types',
      propName: 'DeviceTypes',
      isAssociation: true,
      hasDependent:['SalesProduct', 'CreativeProducts', 'Strategy', 'CustomCriteriaPresets'],
      hasMany: true,
      formatValue: ''
    },
    {
      displayName: 'Sales Product',
      propName: 'SalesProduct',
      displayProp: 'SalesProduct.name',
      isAssociation: true,
      hasDependent:['Strategy', 'DeviceTypes', 'CreativeProducts', 'CustomCriteriaPresets'],
      formatValue: ''
    },
    {
      displayName: 'Creative Products',
      propName: 'CreativeProducts',
      hasDependent:[
        'SalesProduct',
        'DeviceTypes',
        'Strategy',
        'CustomCriteriaPresets',
        'creativePremiumPercent'
      ],
      isAssociation: true,
      hasMany: true,
      formatValue: ''
    },
    {
      displayName: 'Targeting Details',
      propName: 'CustomCriteriaPresets',
      isAssociation: true,
      hasMany: true,
      formatValue: ''
    },
    {
      displayName: 'Pubs',
      propName: 'Pubs',
      hasMany: true,
      formatValue: ''
    },
    {
      displayName: 'Target Language',
      propName: 'targetLanguage',
      formatValue: 'boolean'
    },
    {
      displayName: 'Package Type',
      propName: 'packageType',
      formatValue: ''
    }
  ],
  [
    {
      displayName: 'Start Date',
      propName: 'start',
      formatValue: 'date'
    },
    {
      displayName: 'End Date',
      propName: 'end',
      formatValue: 'date'
    },
    {
      displayName: 'IO Rate Type',
      propName: 'IoRateType',
      displayProp: 'IoRateType.name',
      isAssociation: true,
      formatValue: ''
    },
    {
      displayName: 'IO Rate',
      propName: 'ioRate',
      formatValue: 'currency',
      hasDependent:['IoRateType']
    },
    {
      displayName: 'Viewability',
      propName: 'viewability',
      formatValue: ''
    },
    {
      displayName: 'Creative Premium(%)',
      propName: 'creativePremiumPercent',
      formatValue: ''
    },
    {
      displayName: 'Data Fees',
      propName: 'DataFees',
      isAssociation: true,
      hasMany: true,
      formatValue: ''
    },
    {
      displayName: 'Contracted Quantity',
      propName: 'contractedQuantity',
      formatValue: ''
    },
    {
      displayName: 'Impression Limit',
      propName: 'impressionsLimit',
      formatValue: ''
    },
    {
      displayName: 'Ad Name Comments',
      propName: 'comments',
      formatValue: ''
    },
    {
      displayName: 'Galileo Comments',
      propName: 'gComments',
      formatValue: ''
    },
    {
      displayName: 'Billing Group',
      propName: 'billingGroup',
      formatValue: ''
    },
    {
      displayName: 'Agency Package Name',
      propName: 'agencyPackageName',
      formatValue: ''
    },
  ],
  [
    {
      displayName: 'Geotargets',
      propName: 'Geotargets',
      formatValue: '',
      hasMany: true
    }
  ]
];
